/**
 * Selectors pour la base de données des médicaments
 */

// Sélecteur de base
export const selectMedicationsDatabaseState = (state) => state.medicationsDatabase;

// Liste des médicaments
export const selectMedications = (state) => 
  state.medicationsDatabase?.medications || [];

// Médicament actuel / sélectionné
export const selectCurrentMedication = (state) => 
  state.medicationsDatabase?.selectedMedication;

// Résultats de recherche
export const selectSearchResults = (state) => 
  state.medicationsDatabase?.searchResults || [];

// Statistiques
export const selectMedicationsStats = (state) => 
  state.medicationsDatabase?.stats;

// Pagination
export const selectPagination = (state) => 
  state.medicationsDatabase?.pagination || {
    page: 1,
    limit: 20,
    total: 0,
  };

export const selectCurrentPage = (state) => 
  state.medicationsDatabase?.pagination?.page || 1;

export const selectTotalPages = (state) => 
  state.medicationsDatabase?.pagination?.totalPages || 0;

export const selectTotalItems = (state) => 
  state.medicationsDatabase?.pagination?.total || 0;

// États de chargement
export const selectMedicationsLoading = (state) => 
  state.medicationsDatabase?.medicationsLoading || false;

export const selectSearchLoading = (state) => 
  state.medicationsDatabase?.searchLoading || false;

export const selectStatsLoading = (state) => 
  state.medicationsDatabase?.statsLoading || false;

// Erreurs
export const selectMedicationsError = (state) => 
  state.medicationsDatabase?.medicationsError;

export const selectSearchError = (state) => 
  state.medicationsDatabase?.searchError;

export const selectStatsError = (state) => 
  state.medicationsDatabase?.medicationsError;

// Sélecteurs combinés
export const selectHasMedications = (state) => 
  (state.medicationsDatabase?.medications?.length || 0) > 0;

export const selectHasSearchResults = (state) => 
  (state.medicationsDatabase?.searchResults?.length || 0) > 0;

export const selectIsLoading = (state) => 
  state.medicationsDatabase?.medicationsLoading || 
  state.medicationsDatabase?.searchLoading || 
  state.medicationsDatabase?.statsLoading || 
  false;
